import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils/apolloError";
import { useResettableMutation } from "../useResettableMutation";
import { AddPermitTypeToRegister, AddPermitTypeToRegisterVariables } from "./__generated__/AddPermitTypeToRegister";

const ADD_PERMIT_TYPE_TO_REGISTER = gql`
  mutation AddPermitTypeToRegister($permitRegisterId: String!, $permitTypeIds: [String!]!) {
    addPermitTypeToRegister(input: { permitRegisterId: $permitRegisterId, permitTypeIds: $permitTypeIds }) {
      succeeded
    }
  }
`;

export function useAddPermitTypeToRegister() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    AddPermitTypeToRegister,
    AddPermitTypeToRegisterVariables
  >(ADD_PERMIT_TYPE_TO_REGISTER, {
    errorPolicy: "all",
  });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
